import React from 'react'
import PropTypes from 'prop-types'

import CustomLink from '@/shared/components/customLink'
import { getSlugUrl } from '@/shared/utils'

const EndOver = ({ data, id, inning }: any) => {
  // const totalRuns = data?.aOverScores?.reduce((acc: any, ball: any) => {
  // 	if (ball?.match(/^[0-9]$/)) {
  // 		acc += Number(ball)
  // 	} else if (ball?.indexOf('wd') > 0 || ball?.indexOf('nb') > 0 || ball?.indexOf('Wd') > 0 || ball?.indexOf('Nb') > 0 || ball?.indexOf('lb') > 0 || ball?.indexOf('Lb') > 0) {
  // 		acc += 1
  // 	}
  // 	return acc
  // }, 0)
  const totalRuns = data?.aOverScores?.reduce((acc: any, ball: any) => {
    if (ball?.match(/^\d+$/)) {
      acc += Number(ball)
    } else if (ball?.match(/^\d+(lb|wd|b|nb)$/i)) {
      // Extract the number before "lb" or "wd" and add it to the total
      const runs = parseInt(ball)
      acc += runs
    } else if (ball?.match(/^(lb|wd)$/i)) {
      acc += 1 // Treat "lb" or "wd" without a number as 1 run
    }
    return acc
  }, 0)

  const oBowler = data?.aBowlers?.[0]?.oBowler

  return (
    <>
      <div
        className={` bg-headersActive sm:border-t border-t-tabBorder rounded-xl sm:rounded-b-none sm:rounded-t-xl p-3 sm:py-5 sm:px-6`}
        id={id}
      >
        <div className="flex justify-between items-center gap-4 pb-3 mb-2.5 sm:mb-3 border-b border-b-tabBorder">
          <div className="flex items-center text-lg leading-[18px] font-bold">
            <div className={` text-textOffWhite border-r-2 border-r-textOffWhite pr-3 mr-3`}>
              <h3 className="mb-0 text-sm sm:text-lg leading-[18px] font-bold">
                Over {data?.sOver}
              </h3>
            </div>
            <div className="text-sm sm:text-lg leading-[18px] font-bold text-textOffWhite">
              {totalRuns} Runs
            </div>
          </div>
          <p className="mb-0 text-sm sm:text-lg text-textOffWhite font-bold text-center">
            {inning?.map((i: any) => i?.nInningNumber === data?.nInningNumber && i?.sShortName)} :{' '}
            {data?.sScore}
          </p>
        </div>
        <div className="flex justify-between items-center gap-5">
          {data?.aBatters?.length !== 0 && (
            <div className="flex sm:items-center justify-start flex-col sm:flex-row gap-2.5 xl:gap-20">
              {data?.aBatters?.map((bat: any) => {
                const oBatter = bat?.oBatter
                return (
                  <p
                    className="whitespace-nowrap text-xs sm:text-base"
                    key={bat?.oBatter?.sFullName}
                  >
                    <span className="text-subSectionText font-medium">
                      {oBatter?.eTagStatus === 'a' && oBatter?.oSeo?.sSlug ? (
                        <CustomLink href={getSlugUrl(`/${oBatter?.oSeo?.sSlug}`)}>
                          {bat?.oBatter?.sFullName ||
                            oBatter?.oPlayer?.sFullName ||
                            bat?.oBatter?.sShortName ||
                            oBatter?.oPlayer?.sShortName}
                        </CustomLink>
                      ) : (
                        bat?.oBatter?.sFullName ||
                        oBatter?.oPlayer?.sFullName ||
                        bat?.oBatter?.sShortName ||
                        oBatter?.oPlayer?.sShortName
                      )}
                    </span>
                    <span className="text-subSectionText ml-1">{bat?.nRuns}</span>
                    <span className="text-textDselected ml-0.5">({bat?.nBallFaced})</span>
                  </p>
                )
              })}
            </div>
          )}
          <div className="flex flex-col sm:flex-row items-center gap-3">
            {data?.aBowlers.length !== 0 && (
              <div
                className={` ${'md:text-center text-center sm:text-end'} flex items-center gap-2 text-xs sm:font-normal`}
              >
                <p className="text-xs sm:text-base font-medium text-textDselected">
                  {oBowler?.eTagStatus === 'a' && oBowler?.oSeo?.sSlug ? (
                    <CustomLink href={getSlugUrl(`/${oBowler?.oSeo?.sSlug}`)}>
                      {data?.aBowlers[0]?.oBowler?.sFullName ||
                        oBowler?.oPlayer?.sFullName ||
                        data.aBowlers[0]?.oBowler?.sShortName ||
                        oBowler?.oPlayer?.sShortName}
                    </CustomLink>
                  ) : (
                    data?.aBowlers[0]?.oBowler?.sFullName ||
                    oBowler?.oPlayer?.sFullName ||
                    data.aBowlers[0]?.oBowler?.sShortName ||
                    oBowler?.oPlayer?.sShortName
                  )}
                </p>
                <p className="text-xs sm:text-base font-medium text-textDselected">
                  {data?.aBowlers[0]?.sOvers}-{data?.aBowlers[0]?.nMaidens}-
                  {data?.aBowlers[0]?.nRunsConceded}-{data?.aBowlers[0]?.nWickets}
                </p>
              </div>
            )}
            <div className={`text-center`}>
              <p className="mb-0 text-xs sm:text-sm font-medium text-t-origin flex items-center gap-1">
                {data?.aOverScores?.map((ball: any, index: number) => {
                  return (
                    <span
                      className={`px-1 uppercase flex items-center justify-center border border-tabBorder rounded-full w-6 h-6 ${
                        ['4', '6'].includes(ball)
                          ? 'bg-blueScore text-white'
                          : ball === 'w'
                            ? 'bg-danger text-white'
                            : ''
                      }`}
                      key={`${ball}-${index}`}
                    >
                      {ball}
                    </span>
                  )
                })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

EndOver.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  inning: PropTypes.array,
  index: PropTypes.number
}

export default EndOver
